{{ currentDate | date:'yyyy-MM-dd' }}